import { searchQueryParams } from '../pages/data-tools/document-search/searchQueryParams';

export const queryKeys = {
  fetchDocumentSearchDataWithoutSearchPhrase: {
    all: 'fetchDocumentSearchDataWithoutSearchPhrase' as const,
    query: (queryParams: searchQueryParams) => [queryKeys.fetchDocumentSearchDataWithoutSearchPhrase.all, queryParams] as const,
  },
};
